import { useState } from 'react';
import { Alert, Button, Modal } from 'antd';
import { Copy } from 'lucide-react';
import { copyToClipboard } from '@/utils/utils';

interface Props {
  open: boolean;
  /** 一次性明文 token 与对应名称；为 null 时弹窗不可见。 */
  data: { name: string; token: string } | null;
  onClose: () => void;
}

/** Token 仅一次明文展示：关闭后无法找回，提示用户必须立即复制。 */
export default function TokenRevealDialog({ open, data, onClose }: Props) {
  const [copied, setCopied] = useState(false);

  async function onCopy() {
    if (!data) return;
    const ok = await copyToClipboard(data.token);
    setCopied(ok);
  }

  return (
    <Modal
      title="Token 已生成（仅此一次明文展示）"
      open={open}
      onCancel={onClose}
      maskClosable={false}
      width={560}
      footer={
        <Button type="primary" onClick={onClose}>
          {copied ? '已复制 · 关闭' : '关闭'}
        </Button>
      }
      afterClose={() => setCopied(false)}
    >
      <Alert
        type="warning"
        showIcon
        message={<b>请立即复制保存。</b>}
        description={
          <>
            关闭后将以 <code>***</code> 形式脱敏，无法找回。如果忘记，需在列表上「重置」生成新的。
          </>
        }
      />
      {data && (
        <>
          <div className="reveal-name">{data.name}</div>
          <div className="reveal-token">
            <code>{data.token}</code>
            <Button icon={<Copy size={14} />} onClick={onCopy}>
              复制
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
}
